module.exports = __webpack_public_path__ + "img/expocicaoPermanenteMenuAberto.2088098a.svg";